import { render, staticRenderFns } from "./failVoteList.vue?vue&type=template&id=69ae171e&scoped=true&"
import script from "./failVoteList.vue?vue&type=script&lang=js&"
export * from "./failVoteList.vue?vue&type=script&lang=js&"
import style0 from "./failVoteList.vue?vue&type=style&index=0&id=69ae171e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae171e",
  null
  
)

export default component.exports